// extracted by mini-css-extract-plugin
module.exports = {"info":"tab-tariffs_info__exZTx","infoText":"tab-tariffs_infoText__3Am6v","block":"tab-tariffs_block__1JHCq","blockCards":"tab-tariffs_blockCards__1dCV3"};